// extracted by mini-css-extract-plugin
export var list = "styles-module__list___iLzX2";
export var item = "styles-module__item___P1Z0R";